import recapitulationCurrentSupplier from "@/i18n/locales/cs/recapitulationCurrentSupplier.json";
import recapitulationSupplyPoint from "@/i18n/locales/cs/recapitulationSupplyPoint.json";

export const InfoEmail = "info@eon.cz";
export const VRBEmail = "vyrobci@eon.cz";
export const B2BEmail = "businessline@eon.cz";

export const propertyOwnerships: { [key: string]: keyof typeof recapitulationSupplyPoint } = {
  M: "owner",
  N: "tenant",
} as const;

export const contractValidities: { [key: string]: keyof typeof recapitulationCurrentSupplier } = {
  PN: "fixedPeriod",
  NN: "indefinitely",
  N: "unknown",
} as const;

export const connectionTypes: { [key: string]: keyof typeof recapitulationSupplyPoint } = {
  TP: "connectionTypeTP",
  KO: "connectionTypeKO",
} as const;

export const DateFormat = "DD.MM.YYYY";

export const sessionStorageKeys = {
  smsSentTime: "smsSentTime",
  smsMobileSignatureSentTime: "smsMobileSignatureSentTime",
  sessionKey: "sessionKey",
  executivePeopleModal: "executivePeopleModal",
  setCustomerTypeInModal: "customerTypeWasSet",
  smsCode: "smsCode",
  storedQueries: "storedQueries",
};

export const QueryParams = {
  modals: {
    modifyContactInfoModal: "modifyContactInfoModal",
  },
  pageHint: "pageHint",
};

export const ReactQueryKeys = {
  getContract: (uuid?: string, isRequest?: boolean) => ["contract/get", uuid, isRequest].filter(x => x),
  generateContract: (uuid?: string, contract?: unknown) => ["contract/generate", uuid, contract].filter(x => x),
  generateContractRequest: (uuid?: string, contract?: unknown) => ["request/generate", uuid, contract].filter(x => x),
  mutateContract: () => ["contract/mutation"],
  getDeposits: (uuid: string, productIds: string[]) => ["contract/deposits/get", uuid, ...productIds],
  getContractsInProgress: (uuid: string) => ["contractsInProgress/get", uuid],
  getSignatureInfo: (uuid: string, mobile?: boolean, isRequest?: boolean) =>
    ["mobileSignatureInfo/get", uuid, mobile, isRequest].filter(x => x),
  getContractsInAddInformation: (uuid: string) => ["contractsToAddInformation/get", uuid],
  getSignatureDesktopInfo: () => ["getSignatureDesktopInfo/get"],
};

// Each Ean code starts with this prefix. User can only the code and prefix will be filled in
export const EanPrefixShort = "859";
export const EanPrefix = "8591824";
export const EicPrefix = "27ZG";

export enum FormattedUnits {
  kW = "kW",
  kWh = "kWh",
  MWh = "MWh",
  m3 = "m³",
}

export const DefaultContractValues = {
  contractSource: null,
  tariff: null,
  ecoType: null,
  greenProduct: false,
  tdS01: false,
  tdS02: false,
  tdS03: false,
  tdS04: false,
  supplyPointUsage: null,
  region: null,
  district: null,
  yearConsumptionVt: null,
  yearConsumptionVtUnits: null,
  yearConsumptionNt: null,
  yearConsumptionNtUnits: null,
  yearConsumption: null,
  yearConsumptionUnits: null,
};

export const REQUIRE_ATTACHMENTS_STATUS = "to_completion_wa";
export const REQUIRE_ATTACHMENTS_STATUS_PREVIOUS_CUSTOMER = "to_completion_wa_previous_customer";
export const ADD_INFORMATION_STATUS = "to_add_information";
export const IS_PROCESSING_STATUS = "processing";
export const FOR_REPAIR_STATUS = "for_repair_wa";
export const OFFER_ACTIVE_STATUS = "offer_active";
